import cx from "classnames";
import { FC } from "react";
import st from "./PriceWithLoader.module.scss";

type PriceWithLoaderProps = {
  loading: boolean;
  height?: number;
  width?: number;
  loaderClassName?: string;
  children?: React.ReactNode;
};

export const PriceWithLoader: FC<PriceWithLoaderProps> = ({
  loading,
  height = 32,
  width = 200,
  loaderClassName = "",
  children,
}) => {
  if (loading) {
    return (
      <div
        className={cx(st.loader, loaderClassName)}
        style={{ height, width }}
      />
    );
  }
  return children;
};
